import {
    SET_DADOS_USUARIO,
    SET_PERMISSOES,
    RESET_STATE,
    SET_FILIAL,
    SET_REGIONAL, SET_TODAS_REGIONAIS, SET_TODAS_EMPRESAS, SET_EMPRESA
} from '../actionTypes';

import { PERMISSOES } from '../../models/Permissoes';
import { getCookie, setCookie } from '../../utils';

const getDadosFromStorage = () => {
    const dadosStr = getCookie("usuario") || localStorage.getItem("usuario");
    return dadosStr ? JSON.parse(dadosStr) : {};
};

const getFilialFromStorage = () => {
    const filialStr = getCookie("filial") || localStorage.getItem("filial");
    return filialStr ? JSON.parse(filialStr) : {};
};

const getRegionalFromStorage = () => {
    const regionalStr = getCookie("regional") || localStorage.getItem("regional");
    return regionalStr ? JSON.parse(regionalStr) : {};
};

const getTodasRegionaisFromStorage = () => {
    const regionaisStr = getCookie("todasRegionais") || localStorage.getItem("todasRegionais");
    return regionaisStr ? JSON.parse(regionaisStr) : [];
};

const getTodasEmpresasFromStorage = () => {
    try {
        const empresasStr = getCookie("todasEmpresas") || localStorage.getItem("todasEmpresas");
        if (!empresasStr || empresasStr === 'undefined') return [];
        return JSON.parse(empresasStr);
    } catch {
        return [];
    }
};

const getEmpresaFromStorage = () => {
    try {
        const empresaStr = getCookie("empresa") || localStorage.getItem("empresa");
        if (!empresaStr || empresaStr === 'undefined') return {};
        return JSON.parse(empresaStr);
    } catch { return {}; }
};

const INITIAL_STATE = {
    dadosUsuario: getDadosFromStorage(),
    permissoes: PERMISSOES,
    empresa: getEmpresaFromStorage(),
    filial: getFilialFromStorage(),
    regional: getRegionalFromStorage(),
    todasRegionais: getTodasRegionaisFromStorage(),
    todasEmpresas: getTodasEmpresasFromStorage()
}

export const usuarioReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case RESET_STATE:
            return {
                ...INITIAL_STATE
            };
        case SET_DADOS_USUARIO:
            const dadosUsuarioStr = JSON.stringify(action.dadosUsuario);
            setCookie("usuario", dadosUsuarioStr);
            localStorage.setItem("usuario", dadosUsuarioStr);
            return {
                ...state,
                dadosUsuario: action.dadosUsuario
            };
        case SET_PERMISSOES:
            return {
                ...state,
                permissoes: action.permissoes
            };
        case SET_EMPRESA:
            const empresaStr = JSON.stringify(action.empresa);
            setCookie("empresa", empresaStr);
            localStorage.setItem("empresa", empresaStr);
            return {
                ...state,
                empresa: action.empresa
            };
        case SET_FILIAL:
            const filialStr = JSON.stringify(action.filial);
            setCookie("filial", filialStr);
            localStorage.setItem("filial", filialStr);
            return {
                ...state,
                filial: action.filial
            };
        case SET_REGIONAL:
            const regionalStr = JSON.stringify(action.regional);
            setCookie("regional", regionalStr);
            localStorage.setItem("regional", regionalStr);
            return {
                ...state,
                regional: action.regional
            }
        case SET_TODAS_REGIONAIS:
            const todasRegionaisStr = JSON.stringify(action.todasRegionais);
            setCookie("todasRegionais", todasRegionaisStr);
            localStorage.setItem("todasRegionais", todasRegionaisStr);
            return {
                ...state,
                regional: action.todasRegionais
            }
        case SET_TODAS_EMPRESAS:
            const todasEmpresasStr = JSON.stringify(action.todasEmpresas);
            setCookie("todasEmpresas", todasEmpresasStr);
            localStorage.setItem("todasEmpresas", todasEmpresasStr);
            return {
                ...state,
                todasEmpresas: action.todasEmpresas
            }
        default:
            return state;
    }
};